import { tosApi } from './tosApi';

export type LogActionUser = {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
};

export type LogAction = {
  id: string;
  action: string;
  created_at: string;
  log_date: string;
  user: LogActionUser | null;
};

export type AvailableUser = {
  id: number;
  name: string;
};

export type LogActionPagination = {
  page: number;
  page_size: number;
  total_count: number;
  total_pages: number;
  has_next: boolean;
  has_previous: boolean;
};

export type LogActionFilters = {
  available_users: AvailableUser[];
  current_user_id: number | null;
};

export type LogActionsResponse = {
  results: LogAction[];
  pagination: LogActionPagination;
  filters: LogActionFilters;
};

export type LogActionsQueryParams = {
  stopoverId: number;
  page?: number;
  pageSize?: number;
  userId?: number | null;
};

const BASE_URL = '/core/log-actions';

export const logActionsApi = tosApi.injectEndpoints({
  endpoints: (build) => ({
    getLogActionsByStopover: build.query<
      LogActionsResponse,
      LogActionsQueryParams
    >({
      query({ stopoverId, page = 1, pageSize = 20, userId }) {
        let url = `${BASE_URL}?stopover_id=${stopoverId}&page=${page}&page_size=${pageSize}`;
        if (userId) {
          url += `&user_id=${userId}`;
        }
        return {
          url,
          method: 'GET',
        };
      },
    }),
  }),
});

export const {
  useGetLogActionsByStopoverQuery,
  useLazyGetLogActionsByStopoverQuery,
} = logActionsApi;
